import { ForeAftEnum } from "open-vessel-definition";
/** Gets the CG at the AFT or FWD of the composed/single bay
 * @param idRef The composed/single bay id
 * @param posRef The position to get the CG that we want to obtain
 * @param lcgVcgTcgAndPairings The calculated LCGs, VCGs and TCGs
 */
export function findReferenceLcg(idRef, posRef, lcgVcgTcgAndPairings) {
    var _a, _b;
    const idParts = idRef.split("-");
    const [bayRefDir, bayRefPair] = idParts;
    const { lcgsBy20Bay } = lcgVcgTcgAndPairings;
    if (posRef === ForeAftEnum.AFT) {
        return Math.min(lcgsBy20Bay[bayRefDir].minAftLcg || Infinity, ((_a = lcgsBy20Bay[bayRefPair]) === null || _a === void 0 ? void 0 : _a.minAftLcg) || Infinity);
    }
    else {
        return Math.max(lcgsBy20Bay[bayRefDir].maxForeLcg || -Infinity, ((_b = lcgsBy20Bay[bayRefPair]) === null || _b === void 0 ? void 0 : _b.maxForeLcg) || -Infinity);
    }
}
